import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { ORGANISATION_TRIP_MODULE } from "../constants/organisation.constants";
import { BEACHCOMBER_COLUMN, CDV_COLUMN, DEFAULT_COLUMN, MCI_COLUMN, MV_COLUMN } from "../constants/organisationColumn";

const subDomain = window.location.host.split('.')[0];
const domain = window.location.host.split('.')[1];
const tripColumns = (): Column[] => {
    if (domain === 'tripmci') return MCI_COLUMN;
    if (subDomain === 'marcovasco') return MV_COLUMN;
    if (subDomain === 'cercledesvoyages' || subDomain === 'continentsinsolites' || subDomain === 'terres-lointaines') return CDV_COLUMN;
    if (subDomain === 'beachcomber' || subDomain === 'verdie-voyages') return BEACHCOMBER_COLUMN;
    return DEFAULT_COLUMN;
};

export const setOrganisationTripListPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: ORGANISATION_TRIP_MODULE,
        default_columns: tripColumns(),
        default_order_by: '',
        default_order: 'asc',
    });
